import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { BasicDataModel } from '../../models/basic-data.model';
import { ActionResultModel } from '../../models/core/action-result.model';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';

@Injectable({
    providedIn: 'root'
})
export class BasicDataResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'basicdata' }));
    }

    get(): Observable<ApiResponseModel<BasicDataModel>> {
        return this._requestService.makeGet<ApiResponseModel<BasicDataModel>>(this.getUrl(''), undefined, undefined, undefined, true);
    }

    update(data: BasicDataModel): Observable<ActionResultModel> {
        return this._requestService.makePut<ActionResultModel>(this.getUrl(''), data);
    }
}
